<template lang="pug">
    RadioGroup(v-model="formValue" @on-change="onChange")
        template(v-for="option in formItem.options" )
            template(v-if="typeof option == 'object'")
                Radio(
                    :label="option.value"
                    :disabled="formItem.disabledOptions?formItem.disabledOptions.includes(option.value):false") {{ option.label }}
            template(v-else)
                Radio(
                    :label="option"
                    :key="option"
                    :disabled="formItem.disabledOptions?formItem.disabledOptions.includes(option):false")
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            formValue: this.value
        };
    },
    methods: {
        onChange(val) {
            this.$emit("input", val);
            this.formItem.watchField(val, this.formData);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/RadioGroup.vue